export const SettingsActions = (data) =>{
    return({
        type : data.type,
        payload : data.payload
    })
}  